import { render, staticRenderFns } from "./shutdown-icon-box.vue?vue&type=template&id=a8d46722&scoped=true&"
import script from "./shutdown-icon-box.vue?vue&type=script&lang=js&"
export * from "./shutdown-icon-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d46722",
  null
  
)

export default component.exports